import React from 'react';
import TryhardH2 from '../../../TryhardMarkups';
import TryhardBoxesCard from './TryhardBoxesCard';
// import TryhardBoxesHero from './TryhardBoxesHero';
import { AnimatePresence, motion } from 'motion/react';
import { BounceTransitionWrap, PageTransitions } from '../../../../../../../utils/transitions';

const TryhardBoxes: React.FC = () => {
    return (
        <motion.div
            layout
            variants={PageTransitions}
            initial='initial'
            animate='animate'
            exit='exit'
            className='flex flex-col items-center gap-y-2'
        >
            <TryhardH2>Deck Boxes</TryhardH2>
            <div className='flex flex-col items-center gap-y-4'>
                <AnimatePresence>
                    <BounceTransitionWrap key={0}>
                        <p className='max-w-96 text-center bg-white bg-opacity-30 px-4 pb-2 pt-3 shadow-lg rounded-lg'>Quality safe-keeping for your precious cards. Fits 100!</p>
                    </BounceTransitionWrap>
                    <BounceTransitionWrap key={1} delay={.5}>
                        <TryhardBoxesCard />
                    </BounceTransitionWrap>
                    {/* <BounceTransitionWrap key={2} delay={.5}>
                        <div className='hidden md:inline'><TryhardBoxesHero /></div>
                    </BounceTransitionWrap> */}
                </AnimatePresence>
            </div>
        </motion.div>
    )
}

export default TryhardBoxes;